import script from "./EditUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditUser.vue?vue&type=script&lang=ts&setup=true"

import "./EditUser.vue?vue&type=style&index=0&id=af37f7b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af37f7b0"]])

export default __exports__